import dayjs from 'dayjs'

import { getBaseUrl } from '../lib/helpers'

// body must be stringified using buildBody before calling getClaimInfo.
const getClaimInfo = async (headers: Headers, body: string) => {
  const response = await fetch(`${getBaseUrl()}claimfileuploaderapi/v1/claim`, {
    method: 'POST',
    body: body,
    headers: headers,
    credentials: 'omit'
  })
  if (!response.ok) return response
  return response.json()
}

const buildBody = (claim: string, dateOfLoss: string) =>
  JSON.stringify({ number: `${claim}`, dateOfLoss: `${dayjs(dateOfLoss).format('MMDDYYYY')}` })

export {
  buildBody,
  getClaimInfo
}
